import type { FunctionComponent, SVGProps } from "react";
import { twMerge } from "tailwind-merge";
import DiscordIcon from "./icons/discord.svg?react";
import TiktokIcon from "./icons/tiktok.svg?react";
import FacebookIcon from "./icons/facebook.svg?react";
import XIcon from "./icons/x.svg?react";
import YoutubeIcon from "./icons/youtube.svg?react";
import InstagramIcon from "./icons/instagram.svg?react";
import TwitterIcon from "./icons/twitter.svg?react";
import LinkedinIcon from "./icons/linkedin.svg?react";
import ZaloIcon from "./icons/zalo.svg?react";
import LineIcon from "./icons/line.svg?react";
import WechatIcon from "./icons/wechat.svg?react";
import GenericIcon from "./icons/generic.svg?react";

type SvgComponent = FunctionComponent<SVGProps<SVGSVGElement>>;

/** 平台名（归一化后）→ 本地图标组件映射 */
const ICON_MAP: Record<string, SvgComponent> = {
  discord: DiscordIcon,
  tiktok: TiktokIcon,
  facebook: FacebookIcon,
  x: XIcon,
  twitter: TwitterIcon,
  youtube: YoutubeIcon,
  instagram: InstagramIcon,
  linkedin: LinkedinIcon,
  zalo: ZaloIcon,
  line: LineIcon,
  wechat: WechatIcon,
  weixin: WechatIcon,
};

/** 单色镂空图标需跟随主题色，避免浅色模式下白色部分消失 */
const MONOCHROME_NAMES = new Set(["x", "generic"]);

const normalize = (name: string) => (name === "企业微信" ? "wechat" : name.toLowerCase().replace(/[\s_-]/g, ""));

interface SocialIconProps {
  name: string;
  className?: string;
}

/** 按平台名称渲染本地图标，未匹配到时使用通用兜底图标 */
export const SocialIcon = ({ name, className }: SocialIconProps) => {
  const key = normalize(name);
  const Icon = ICON_MAP[key] ?? GenericIcon;
  const isMonochrome = Icon === GenericIcon || MONOCHROME_NAMES.has(key);
  return <Icon className={twMerge("size-[29.25px]", isMonochrome && "text-kds-fg", className)} />;
};
